import React, {Component} from 'react';
import {ShipContext} from './context/ShipContext';
import {ships, areasNamesMap} from './settings';
import HotspotCameraDependant from './HotspotCameraDependant';
import HotspotStatic from './HotspotStatic';
import AreaCategories from './AreaCategories';
import CloseupArea from './CloseupArea';

class ApplicationArea extends Component {
    constructor(props) {
        super(props);

        this.hotspotRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.threeDShip) {
            this.props.addHotspotRef(this.hotspotRef.current);
        }
    }

    render() {
        let hotspot;

        if (this.props.threeDShip) {
            hotspot = (
                <HotspotCameraDependant
                    areaName={this.props.area.name}
                    hotspotLabelText={this.props.area.displayName}
                    areaId={this.props.area.name}
                    moveCameraToPosition={this.props.moveCameraToPosition}
                    getTwoDCoordinatesFromThreeD={this.props.getTwoDCoordinatesFromThreeD}
                    shipHasLoaded={this.props.shipHasLoaded}
                    ref={this.hotspotRef}
                />
            )
        } else {
            hotspot = (
                <HotspotStatic
                    areaName={this.props.area.name}
                    hotspotLabelText={this.props.area.displayName}
                    areaId={this.props.area.name}
                />
            )
        }

        return (
            <div className="ships-viewer-area"
                 key={this.props.area.id}
            >
                {hotspot}
                <AreaCategories
                    areaName={this.props.area.name}
                    areaDisplayName={this.props.area.displayName}
                    areaSubcategories={this.props.area.subareas}
                    areaId={this.props.area.name}
                    moveCameraToInitialPosition={this.props.threeDShip ? this.props.moveCameraToInitialPosition : null}
                />
                {this.props.shipType !== ships.offshore && this.props.area.name === areasNamesMap.engineRoom &&
                <CloseupArea
                    closeupAreaSubareas={this.props.area.subareas}
                    areaId={this.props.area.name}
                    areaName={this.props.area.name}
                    engineRoomImgUrl={this.props.engineRoomImgUrl}
                />
                }
            </div>
        )
    }
}

function ApplicationAreaWithContext(props) {
    return (
        <ShipContext.Consumer>
            {(context) =>
                <ApplicationArea
                    shipType={context.shipType}
                    {...props}
                />
            }
        </ShipContext.Consumer>
    )
}

export default ApplicationAreaWithContext;